import { votingService } from '../services/votingservice.js';

let Vue = null;

function vueSet(array, key, value) {
  if (Vue) {
    Vue.set(array, key, value);
  } else {
    array[key] = value;
  }
}

function vueDelete(array, key) {
  if (Vue) {
    Vue.delete(array, key);
  } else {
    delete array[key];
  }
}

export default {
  namespaced: true,
  state: {
    sessionPollInfoList: {}
  },
  init: function (vue, store) {
    Vue = vue;
  },
  mutations: {
    sessionPollInfoAdded(state, info) {
      vueSet(state.sessionPollInfoList, info.sessionId, info);
    },
    sessionPollInfoRemoved(state, session_id) {
      vueDelete(state.sessionPollInfoList, session_id);
    },
    sessionPollStateUpdated(state, poll_state) {
      let item = state.sessionPollInfoList[poll_state.sessionId];
      if (item) {
        let current_poll = poll_state.currentPoll;
        if (current_poll != null) {
          vueSet(current_poll, 'updatedTime', Date.now());
        }
        vueSet(item, 'currentPoll', current_poll);
        vueSet(item, 'currentLeaderboard', poll_state.currentLeaderboard);
        vueSet(item, 'resourceDownloadDetails', poll_state.resourceDownloadDetails);

        // clear live poll count if we are not in open or closing state to avoid using old results
        if (item.livePollCount && poll_state.currentPoll && poll_state.currentPoll.pollState && poll_state.currentPoll.pollState !== 'open' && poll_state.currentPoll.pollState !== 'closing') {
          item.livePollCount = null;
        }
      }
    },
    livePollCountUpdated(state, live_count) {
      let item = state.sessionPollInfoList[live_count.sessionId];
      if (item) {
        item.livePollCount = live_count;
      }
    }
  },
  getters: {
    getSessionPollState: state => session_id => {
      let item = state.sessionPollInfoList[session_id];
      return item == null ? null : item.currentPoll;
    },
    getSessionLeaderboard: state => session_id => {
      let item = state.sessionPollInfoList[session_id];
      return item == null ? null : item.currentLeaderboard;
    },
    getSessionResourceDownloadDetails: state => session_id => {
      let item = state.sessionPollInfoList[session_id];
      return item == null ? null : item.resourceDownloadDetails;
    },
    getSessionLivePollCount: state => session_id => {
      let item = state.sessionPollInfoList[session_id];
      return item == null ? null : item.livePollCount;
    }
  },
  actions: {
    addPollStateListener(context, { sessionId }) {
      let info = getPollInfo(context, sessionId);
      let create_info = info == null;

      // create new session poll info
      if (create_info) {
        info = {
          sessionId: sessionId,
          currentPoll: null,
          currentLeaderboard: null,
          livePollCount: null,
          unsubscribe: null
        };
        listenerCounts[sessionId] = 0;
      }

      // setup service subscription if we are not already subscribed
      if (listenerCounts[sessionId] === 0) {
        // subscribe and add handlers
        let subscription = votingService.subscribeForSessionPollState(sessionId, response => {
          if (response.status !== 'success') {
            context.commit('errors/addError', response, { root: true });
          }
        });
        subscription.addHandler('SessionPollStateVer2', msg => {
          context.commit('sessionPollStateUpdated', msg);
        });
        subscription.addHandler('LivePollCountVer2', msg => {
          context.commit('livePollCountUpdated', msg);
        });
        // create unsubscribe function
        info.unsubscribe = function () {
          listenerCounts[sessionId]--;
          if (listenerCounts[sessionId] === 0) {
            subscription.unsubscribe();
            context.commit('sessionPollInfoRemoved', sessionId);
          }
        };
      }

      // increment listener count
      listenerCounts[sessionId]++;

      // add poll info to state
      if (create_info) {
        context.commit('sessionPollInfoAdded', info);
      }

      return {
        sessionId: sessionId,
        remove: () => info.unsubscribe()
      };
    }
  }
};

let listenerCounts = {};

function getPollInfo(context, session_id) {
  return context.state.sessionPollInfoList[session_id];
}


//////////////////
// WEBPACK FOOTER
// ../ReactorJSCore/dist/store/voting.js
// module id = null
// module chunks = 